import { render, staticRenderFns } from "./ContentWithImage.vue?vue&type=template&id=aea8ffa8&"
import script from "./ContentWithImage.vue?vue&type=script&lang=ts&"
export * from "./ContentWithImage.vue?vue&type=script&lang=ts&"
import style0 from "./ContentWithImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdaptiveImageNew: require('/tmp/build_1fde6b87/src/components/media/AdaptiveImageNew.vue').default,Button: require('/tmp/build_1fde6b87/src/components/button/Button.vue').default,BlockWrapper: require('/tmp/build_1fde6b87/src/components/block/BlockWrapper.vue').default})
